export enum AlertType {
    SUCCESS,
    ERROR,
    INFO
}

export type Alert = {
    name: string
    description: string
    type: AlertType
    created: number
}